import { render, staticRenderFns } from "./ConfirmPasswordReset.vue?vue&type=template&id=4b6cc2f2&scoped=true"
import script from "./ConfirmPasswordReset.vue?vue&type=script&lang=js"
export * from "./ConfirmPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPasswordReset.vue?vue&type=style&index=0&id=4b6cc2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6cc2f2",
  null
  
)

export default component.exports